import React, { useEffect, useState } from "react";
import "./index.scss";
import { Box, Grid2 } from "@mui/material";
import { useTheme } from "@emotion/react";
import DateIcon from "assets/images/dateIcon.png";
import ClockIcon from "assets/images/clockIcon.png";
import LocationIcon from "assets/images/locationIcon.png";
import moment from "moment-jalaali";
import useInfoContext from "hooks/useInfoContext";

const ConcertDetails = () => {
  const { itemEvent, itemEventDetail } = useInfoContext();
  const [shamsiDate, setShamsiDate] = useState("");
  const [eventTime, setEventTime] = useState("");
  const theme = useTheme();

  const convertToShamsi = (dateString) => {
    if (!dateString) return { shamsi: "نامشخص", time: "نامشخص" };
    const shamsi = moment(dateString).format("jYYYY/jM/jD");
    const time = moment(dateString).format("HH:mm");
    return { shamsi, time };
  };

  useEffect(() => {
    const { shamsi, time } = convertToShamsi(itemEventDetail?.date);
    setShamsiDate(shamsi);
    setEventTime(time);
  }, [itemEventDetail?.date]);

  const dataItems = [
    { title: "تاریخ اجرا", data: shamsiDate, icon: DateIcon },
    {
      title: "ساعت اجرا",
      data: `${eventTime} تا ${parseInt(eventTime) + 2}:00`,
      icon: ClockIcon,
    },
    {
      title: "محل برگزاری",
      data: itemEventDetail?.location,
      icon: LocationIcon,
    },
  ];

  return (
    <Box className="concert-detail-copmonent">
      <img
        src={itemEvent?.bannerURL}
        alt=""
        style={{ maxWidth: "100%", borderRadius: "8px", padding: "5px" }}
      />
      {dataItems?.map((item, index) => (
        <React.Fragment key={index}>
          <Grid2 container columns={12} className="grid-box-item">
            <Grid2 item size={{ xs: 1 }} className="icon-box">
              <Box className="flex-box">
                <img src={item.icon} alt="" />
              </Box>
            </Grid2>
            <Grid2 item size={{ xs: 5 }} className="title-text">
              {item.title}
            </Grid2>
            <Grid2 item size={{ xs: 6 }} className="data-text">
              <Box className="flex-box">{item.data}</Box>
            </Grid2>
          </Grid2>
          {index < dataItems.length - 1 && (
            <hr
              size={1}
              color={theme.palette.defultText.main}
              className="divider"
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default ConcertDetails;
